import { useSelector } from 'react-redux';

import { ATTENDEE_SECTIONS, APPLICATION_SECTIONS } from '@framework/constants/enums';

import { getCurrentAppSection } from '@redux/selectors/AppSelector';

const useIsMinutesEditorView = () => {
    const currentSection = useSelector(getCurrentAppSection);
    const isMinutesEditorViewMode = currentSection === ATTENDEE_SECTIONS.MINUTES_EDITOR;
    const isMinutesEditorEditMode = currentSection === APPLICATION_SECTIONS.MINUTES_EDITOR;
    const isMinutesEditorView = isMinutesEditorViewMode || isMinutesEditorEditMode;

    return {
        isMinutesEditorViewMode,
        isMinutesEditorEditMode,
        isMinutesEditorView
    };
};

export default useIsMinutesEditorView;
